import { render, staticRenderFns } from "./my-lp.vue?vue&type=template&id=25996d06&scoped=true&"
import script from "./my-lp.vue?vue&type=script&lang=js&"
export * from "./my-lp.vue?vue&type=script&lang=js&"
import style0 from "./my-lp.vue?vue&type=style&index=0&id=25996d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25996d06",
  null
  
)

export default component.exports